module.exports = __webpack_public_path__ + "static/media/3.00f6b8e3.webp";